import { useCallback, useState } from 'react'
import { reportAPI } from '@/api'
import { useAddAlert } from '@/hooks/useAddAlert'
import { mapSigningStateToContractStatus } from '@pages/Admin/Reports/ContractReport/utils/contractSigningState.utils'
import {
  ContractLoadingState,
  StudentContractDock,
} from './studentContracts.types'

export const useStudentContractActions = (
  onContractChanged: () => void | Promise<void>,
) => {
  const addAlert = useAddAlert()
  const [contractLoading, setContractLoading] = useState<ContractLoadingState>(
    null,
  )

  const handleContractEndDateChange = useCallback(
    async (contract: StudentContractDock, date: string | null) => {
      setContractLoading({ id: contract.id, field: 'endDate' })
      try {
        await reportAPI.contractReportUpdate({
          id: contract.id,
          data: { contract_end_date: date },
        })
        await onContractChanged()
      } catch {
        addAlert({
          type: 'error',
          message: 'Не удалось обновить дату завершения договора',
        })
      } finally {
        setContractLoading(null)
      }
    },
    [addAlert, onContractChanged],
  )

  const handleContractToggleProcessed = useCallback(
    async (contract: StudentContractDock) => {
      setContractLoading({ id: contract.id, field: 'processed' })
      try {
        await reportAPI.contractReportToggleProcessed({ id: contract.id })
        await onContractChanged()
      } catch {
        addAlert({
          type: 'error',
          message: 'Не удалось изменить статус обработки договора',
        })
      } finally {
        setContractLoading(null)
      }
    },
    [addAlert, onContractChanged],
  )

  const handleContractSigningStateChange = useCallback(
    async (contract: StudentContractDock, signingState: string) => {
      setContractLoading({ id: contract.id, field: 'signingState' })
      try {
        await reportAPI.contractReportUpdate({
          id: contract.id,
          data: {
            contract_status: mapSigningStateToContractStatus(signingState),
          },
        })
        await onContractChanged()
      } catch {
        addAlert({
          type: 'error',
          message: 'Не удалось обновить статус подписания',
        })
      } finally {
        setContractLoading(null)
      }
    },
    [addAlert, onContractChanged],
  )

  return {
    contractLoading,
    handleContractEndDateChange,
    handleContractToggleProcessed,
    handleContractSigningStateChange,
  }
}
